

const state = {
    
    blocks:[
        {
            id:1,
            name: 'Rezepte',
            color: '#fff',   
            columns:1,
            blockcomponents: {
                columns: [
                    //left Column
                    [
                        {
                            id:1,
                            name:'formprojectrecipestable',
                            attributes: {
                                placeholder:"Recipes",
                                size:"xs10",
                                invertedsize:"xs1",                                
                                icon:"search",                                
                                setter: 'projects/PROJECT_SET_ENTITIES',                                    
                                items:'projects/entities',
                                variable:'entity_ids',
                                withcheck:false,
                                withsearch:false,
                                withdialog:true,
                                
                            }                                    
                        }
                    ],                   
                ]
            },
        },
        
    ]
    
};

export default {
  namespaced: false,
  state,
  
};